import React from 'react';
import { QuestionBankUpload as NewQuestionBankUpload } from './question-bank-upload';

const QuestionBankUpload = () => {
  return <NewQuestionBankUpload />;
};

export default QuestionBankUpload; 